import React, { useState } from 'react';

import type { CompanyInfoDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';

import Card from '../../../components/common/Card';
import CompanyInfoForm from '../../../components/forms/CompanyInfoForm';
import AdminLayout from '../../../components/layout/AdminLayout';
import { useCompanyInfoApi } from '../../../hooks/useCompanyInfoApi';

const CompanyInfoCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { create } = useCompanyInfoApi();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompanyInfoDTO): Promise<void> => {
    setIsSubmitting(true);
    try {
      await create(data);
      navigate('/admin/companyinfo');
    } catch (error) {
      console.error('Error creating company info:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="Create Company Info"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
    >
        <CompanyInfoForm
          initialValues={{} as CompanyInfoDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/companyinfo')}
          isSubmitting={isSubmitting}
        />
    </AdminLayout>
  );
};

export default CompanyInfoCreate;
